import { IconsProps } from 'src/svgs/Viagogo/icon-types';
import { SvgWrapper } from 'src/svgs/Viagogo/svg-wrapper/icon-wrapper';

export function NavSearchIcon(props: IconsProps) {
  return (
    <SvgWrapper {...props}>
      <g transform="translate(2 2)">
        <path
          d="M8.38454 14.7691C9.80253 14.7691 11.117 14.3129 12.1766 13.5308L15.9687 17.3229C16.3426 17.6968 16.9489 17.6968 17.3229 17.3229C17.6968 16.9489 17.6968 16.3426 17.3229 15.9687L13.5308 12.1766C14.3129 11.117 14.7691 9.80253 14.7691 8.38454C14.7691 4.85845 11.9106 2 8.38454 2C4.85845 2 2 4.85845 2 8.38454C2 11.9106 4.85845 14.7691 8.38454 14.7691ZM12.8537 8.38454C12.8537 5.91628 10.8528 3.91536 8.38454 3.91536C5.91628 3.91536 3.91536 5.91628 3.91536 8.38454C3.91536 10.8528 5.91628 12.8537 8.38454 12.8537C10.8528 12.8537 12.8537 10.8528 12.8537 8.38454Z"
          fillRule="evenodd"
          clipRule="evenodd"
          fill="inherit"
        />
      </g>
    </SvgWrapper>
  );
}
